"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var optionContainerRenderer_1 = require("./renderer/optionContainerRenderer");
function SuggestItem(_a) {
    var highlightPattern = _a.highlightPattern, selected = _a.selected, text = _a.text, hovered = _a.hovered, _b = _a.interactable, interactable = _b === void 0 ? true : _b, disabled = _a.disabled, onClick = _a.onClick, contentRenderer = _a.contentRenderer, _c = _a.containerRenderer, containerRenderer = _c === void 0 ? optionContainerRenderer_1.createOptionContainerRenderer() : _c, option = _a.option, style = _a.style, rest = __rest(_a, ["highlightPattern", "selected", "text", "hovered", "interactable", "disabled", "onClick", "contentRenderer", "containerRenderer", "option", "style"]);
    var containerRef = react_1.useRef(null);
    var _d = react_1.useState(false), active = _d[0], setActive = _d[1];
    var _e = react_1.useState(false), internalHovered = _e[0], setHovered = _e[1];
    var onMouseDownHandler = function (event) {
        var _a;
        interactable && setActive(true);
        (_a = rest.onMouseDown) === null || _a === void 0 ? void 0 : _a.call(rest, event);
    };
    var onMouseUpHandler = function (event) {
        var _a;
        setActive(false);
        (_a = rest.onMouseUp) === null || _a === void 0 ? void 0 : _a.call(rest, event);
    };
    var onMouseEnterHandler = function (event) {
        var _a;
        interactable && setHovered(true);
        (_a = rest.onMouseLeave) === null || _a === void 0 ? void 0 : _a.call(rest, event);
    };
    var onMouseLeaveHandler = function (event) {
        var _a;
        setActive(false);
        setHovered(false);
        (_a = rest.onMouseLeave) === null || _a === void 0 ? void 0 : _a.call(rest, event);
    };
    var content = contentRenderer({
        disabled: !!disabled,
        active: selected || active,
        hovered: hovered || internalHovered,
        option: option,
        text: text || '',
        matchPattern: highlightPattern
    });
    var needToScroll = function () {
        if (!containerRef.current || typeof containerRef.current.scrollIntoView !== 'function') {
            return false;
        }
        var el = containerRef.current;
        var parentEl = el.parentNode;
        var elHeight = el.getBoundingClientRect().height;
        var menuHeight = parentEl.clientHeight;
        var accuracyFactor = 4;
        var elementTopBoundaryOffset = el.offsetTop - parentEl.scrollTop;
        var beyondTopBoundary = elementTopBoundaryOffset + accuracyFactor < 0;
        var beyondBottomBoundary = menuHeight - elementTopBoundaryOffset - elHeight + accuracyFactor < 0;
        return beyondBottomBoundary || beyondTopBoundary;
    };
    react_1.useEffect(function () {
        var _a;
        if (selected && needToScroll()) {
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        }
    }, []);
    react_1.useEffect(function () {
        var _a;
        if (hovered && needToScroll()) {
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        }
    });
    return containerRenderer({
        disabled: !!disabled,
        active: selected || active,
        hovered: hovered || internalHovered,
        option: option,
        content: content,
        text: text || '',
        matchPattern: highlightPattern,
        style: style,
        control: {
            ref: selected || hovered ? containerRef : undefined,
            onMouseDown: onMouseDownHandler,
            onMouseUp: onMouseUpHandler,
            onMouseEnter: onMouseEnterHandler,
            onMouseLeave: onMouseLeaveHandler,
            onClick: onClick
        }
    });
}
exports.SuggestItem = SuggestItem;
//# sourceMappingURL=SuggestItem.js.map